import React, { useState, useCallback, useEffect,useRef } from 'react';
import { useFormContext } from './formContext';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import { ColorRing } from 'react-loader-spinner';
import { sendOTPForTermsheet, verifyOTPForTermsheet } from '@/lib/credlixBypass';
import { useRouter } from 'next/router';
import { pushCleverTapEvent } from '../pushCleverTapEvent';

const ContactFormStep1 = ({ showStep1,pageTitle }) => {
    const router = useRouter();
    const { locale } = router;
    const eventTriggeredRef = useRef(false);

    const { state, dispatch } = useFormContext();
    const { formData } = state;
    // const notificationMethods = [
    //     { id: 'Yes', title: t.SCF2_export_y },
    //     { id: 'No', title: t.SCF2_export_n },
    // ]
    const checkArray = [
        { id: 'option1', value: 'domestic', name: 'Domestic' },
        { id: 'option2', value: 'export', name: 'Export & Import' },
    ].filter(item => !(router.pathname === '/import-factoring' && item.value === 'domestic'));
    const [showUSDInput, setShowUSDInput] = useState(false);
    const [loader, setLoader] = useState(false);
    // const [exportValue, setExportValue] = useState('export');
    const [exportValue, setExportValue] = useState('domestic');
    const [currencyVal, setCurrencyVal] = useState(formData?.currency || '');
    const [financeAmt, setFinanceAmt] = useState(formData?.financeAmt || '');
    const [phoneNumberCfForm, setPhoneNumberCfForm] = useState(formData?.phone || '');
    const [website, setWebsite] = useState(formData?.website || '');
    const { executeRecaptcha } = useGoogleReCaptcha('');
    const [phoneErrorMsg, setPhoneErrorMsg] = useState(false);
    const [showOtpField, setShowOtpField] = useState(false);
    const [countdown, setCountdown] = useState(60);
    const [otpBtnDisabled, setOtpBtnDisabled] = useState(true);
    const [getOtp, setGetOtp] = useState(false);
    const [requestIdCfForm, setRequestIdCfForm] = useState('');
    const [phVerifiedCfForm, setPhVerifiedCfForm] = useState(false);
    const [networkErrorCfForm, setNetworkErrorCfForm] = useState(false);
    const [financeAmtError, setFinanceAmtError] = useState(false);
    const [allFieldsError, setAllFieldsError] = useState(false);
    const [responseOfOTP, setResponseOfOTP] = useState(false);
    const [otpIncorrect, setOtpIncorrect] = useState(false);
    const [otpNumericIncorrect, setOtpNumericIncorrect] = useState(false);
    const [group, setGroup] = useState(null);
    const pageName = process.env.URL + router.asPath;
    
    const handleCaptchaSubmitCfForm = useCallback(async () => {
        if (!executeRecaptcha) {
            return false;
        }

        try {
            const gReCaptchaToken = await executeRecaptcha();
            return gReCaptchaToken
        } catch (error) {
            console.error('Error executing reCaptcha:', error);
        }
    }, [executeRecaptcha]);

    const handleRadioButtonChange = (e) => {
        const val = e.target.value;
        setExportValue(val);
        setShowUSDInput(val === 'export');
       

    };
    const trackEvent = () => {
        if (router.asPath === '/') {
            pushCleverTapEvent("Form_Start", { "PageName": 'HomePage' });
         } else if (router.asPath.includes('/blogs')) {
                pushCleverTapEvent("Blog_Form_Start", { "PageName": 'Blog_Page' });
        } else if (router.asPath.includes('/hsn-code')) {
                pushCleverTapEvent("HSN_Page_form_start", { "PageName": 'HSN_Page' });
        }else if (router.asPath.includes('/contact-us')) {
                pushCleverTapEvent("Contact_us_Form_Start", { "PageName": 'Contact_Us_Page' });
        } else if (router.asPath.includes('/credlix-finsight')) {
                pushCleverTapEvent("Finsights_Form_Start", { "PageName": 'Finsights' });
        } else if (router.asPath.includes('/export-factoring/purchase-order-financing')) {
                pushCleverTapEvent("PO_Finance_Form_Start", { "PageName": 'PO_Finance' });
        } else if (router.asPath.includes('/export-factoring/invoice-discounting-platform')) {
            pushCleverTapEvent("SID_Form_Start", { "PageName": 'Sales_Bill_Discounting' });
        } else if (router.asPath.includes('/enterprise/vendor-financing-india')) {
            pushCleverTapEvent("VF_Form_Start", { "PageName": 'Vendor_Finance' });
        } else if (router.asPath.includes('/enterprise/channel-financing-india')) {
          pushCleverTapEvent("CF_Form_Start", { "PageName": 'Channel_Finance' });
        } else if (router.asPath.includes('/enterprise/early-payment-discount')) {
            pushCleverTapEvent("EP_Form_Start", { "PageName": 'Early_Payment' });
        }
    };
    const financeAmount = (e) => {
        const value = e.target.value;
        if (!eventTriggeredRef.current) {
            trackEvent();
            eventTriggeredRef.current = true;
        }
        const regex = /^[0-9]*$/;
        if (value != '' && value != null && regex.test(value) == true) {
            if (showUSDInput == true) {
                setCurrencyVal('USD')
            } else {
                setCurrencyVal('INR')
            }
            setFinanceAmtError(false)
            setFinanceAmt(value)
        } else {
            setFinanceAmtError(true)
        }
        setFinanceAmt(value)

    }

    const checkPhoneCfForm = (e) => {
        const value = e.target.value;
        const regex = /^[0-9]*$/;

        // setOtpBtnDisabled(false);

        if (value !== '' && value.length == 10 && regex.test(value)) {
            setOtpBtnDisabled(false);
            setShowOtpField(false);
            setPhoneNumberCfForm(value);
            setPhoneErrorMsg(false);
            setPhVerifiedCfForm(false);
        } else {
            setPhVerifiedCfForm(false);
            setPhoneErrorMsg(true);
            setOtpBtnDisabled(true);
        }
        setPhoneNumberCfForm(value);
    };

    /* Sent Otp over Phone */
    const sendOTPCfForm = async () => {

        const captchaToken = await handleCaptchaSubmitCfForm();

        setLoader(true);
        setShowOtpField(true);


        try {
            const response = await sendOTPForTermsheet(phoneNumberCfForm, captchaToken);
            const res = await response.json();

            if (response.status == 200) {
                const result = res.result.requestId;
                setGetOtp(true)
                setRequestIdCfForm(result);
                // updateData('Phone', phoneNumber)
                window.gtag('event', 'sendOTPfinance', {
                    'event_category': 'Get financed',
                    'event_label': 'Send OTP'
                });

            } else {
                console.error('Error sending OTP:', response.statusText);
            }
        } catch (error) {
            startCountdownCfForm();
        } finally {
            startCountdownCfForm();
        }


    };
    const moveToNextInputCfForm = (currentInput, nextInputId) => {
        let maxLength = parseInt(currentInput.getAttribute('maxLength'));
        let currentLength = currentInput.value.length;

        if (currentLength === maxLength) {
            document.getElementById(nextInputId).focus();
        }
        verifyPhoneNumberCfForm()
    }
    /* Verify Otp over Phone */
    const verifyOTPCfForm = async (enteredOtp) => {

        const captchaToken = await handleCaptchaSubmitCfForm();
        setLoader(true);
        setShowOtpField(true)
        try {
            const response = await verifyOTPForTermsheet(requestIdCfForm, enteredOtp, captchaToken);
            if (response.status == 200) {
                const result = response.data;
                setPhVerifiedCfForm(true);
                setGetOtp(false)
                setLoader(false)
                setShowOtpField(false)
                setNetworkErrorCfForm(false)
                setResponseOfOTP(true);
                if (phVerifiedCfForm) {
                    setOtpBtnDisabled(true)
                }
                if (router.asPath === '/') {
                    pushCleverTapEvent("Send_OTP_Finance", { "PageName": 'HomePage', "number": phoneNumberCfForm });
                 } else if (router.asPath.includes('/blogs')) {
                    pushCleverTapEvent("Blog_OTP_Submit", { "PageName": 'Blog_Page', "number": phoneNumberCfForm });
                } else if (router.asPath.includes('/hsn-code')) {
                    pushCleverTapEvent("HSN_OTP_Submit", { "PageName": 'HSN_Page', "number": phoneNumberCfForm });
                } else if (router.asPath.includes('/contact-us')) {
                    pushCleverTapEvent("Contact_us_OTP_Submit", { "PageName": 'Contact_Us_Page', "number": phoneNumberCfForm });
                }else if (router.asPath.includes('/credlix-finsight')) {
                    pushCleverTapEvent("Finsights_OTP_Submit", { "PageName": 'Finsights', "number": phoneNumberCfForm });
                } else if (router.asPath.includes('/export-factoring/purchase-order-financing')) {
                    pushCleverTapEvent("PO_Finance_OTP_Submitted", { "PageName": 'PO_Finance', "number": phoneNumberCfForm });
             } else if (router.asPath.includes('/export-factoring/invoice-discounting-platform')) {
                    pushCleverTapEvent("SID_OTP_Submitted", { "PageName": 'Sales_Bill_Discounting', "number": phoneNumberCfForm });
             }else if (router.asPath.includes('/enterprise/vendor-financing-india')) {
                    pushCleverTapEvent("VF_OTP_Submitted", { "PageName": 'Vendor_Finance', "number": phoneNumberCfForm });
             }else if (router.asPath.includes('/enterprise/channel-financing-india')) {
                    pushCleverTapEvent("CF_OTP_Submitted", { "PageName": 'Channel_Finance', "number": phoneNumberCfForm });
             } else if (router.asPath.includes('/enterprise/early-payment-discount')) {
                pushCleverTapEvent("EP_OTP_Submitted", { "PageName": 'Early_Payment', "number": phoneNumberCfForm });
             } 
             window.gtag("event", "otp_verified");
            } else {
                setOtpIncorrect(true);
                setPhVerifiedCfForm(false);
            }

        } catch (error) {
            setOtpIncorrect(true);
            setNetworkErrorCfForm(true)
            console.error('verifyOTPCfForm :: Error verifying OTP:', error);
        }
    };

    const verifyPhoneNumberCfForm = () => {
        const enteredOTP = Array.from({ length: 6 }, (_, index) =>
            document.getElementById(`digit${index + 1}`).value
        ).join('');
        if (!/^\d+$/.test(enteredOTP)) {
            setOtpNumericIncorrect(true);
        } else {
            // Check if enteredOTP is a 6-digit number
            if (enteredOTP.length === 6) {
                setOtpNumericIncorrect(false); // Reset incorrect OTP state
                setGetOtp(false);
                setLoader(false);
                verifyOTPCfForm(enteredOTP);

            } else {
                setOtpNumericIncorrect(true);
            }
        }
    }
    const startCountdownCfForm = () => {
        setCountdown(30);
        // setOtpBtnDisabled(true);

        const countdownInterval = setInterval(() => {
            setCountdown((prevCountdown) => {
                const newCountdown = prevCountdown - 1;
                if (newCountdown === 0) {
                    clearInterval(countdownInterval);
                    setOtpBtnDisabled(false);

                } else {
                    setLoader(false);
                }

                return newCountdown >= 0 ? newCountdown : 0;
            });


        }, 500);
    };
    const websiteUrl = (e) => {
        setWebsite(e.target.value)
    }



    const handleNext = () => {
        // Check if all required fields are filled
        if (exportValue && currencyVal && financeAmt && phoneNumberCfForm && phVerifiedCfForm || state.formData?.otpResponse) {
            setAllFieldsError(false); // Reset any previous error
            if (state.step === 1) {
                showStep1(true)
            }

            dispatch({
                type: 'UPDATE_FORM_DATA',
                payload: {
                    exportValue: exportValue,
                    currency: currencyVal,
                    financeAmt: financeAmt,
                    phone: phoneNumberCfForm,
                    website: website,
                    otpResponse: responseOfOTP
                }
            });
            dispatch({
                type: 'NEXT_STEP',
                payload: {
                    exportValue: exportValue,
                    currency: currencyVal,
                    financeAmt: financeAmt,
                    phone: phoneNumberCfForm,
                    website: website,
                    otpResponse: responseOfOTP
                }
            });
            gtag('event', 'getFinanced', {
                'event_category': 'Get financed',
                'event_label': 'Get finance tab'
            });
            if (group === 'clevertap') {
                pushCleverTapEvent("getFinanced", { "Page Name": pageName , "number": phoneNumberCfForm});
            }
            // console.log('Form submitted, gtag event fired.');
        } else {
            setAllFieldsError(true); // Show error if any required field is missing
        }
        // gtag('event', 'action', {
        //     'event_category': '2 steps contact form',
        //     'event_label': 'Go to next step'
        // });
       

    };
    useEffect(() => {
        if (phVerifiedCfForm) {
            setOtpBtnDisabled(true)
        }
    }, [phVerifiedCfForm,otpBtnDisabled]);

    useEffect(() => {
        if (router.pathname === '/import-factoring' || router.pathname === '/export-factoring-interest-subvention') {
            setExportValue('export');
            setShowUSDInput(true);
            setCurrencyVal('USD');
        } else {
            setExportValue('domestic');
            setShowUSDInput(false);
            setCurrencyVal('INR');
        }      
    }, [router.pathname]);

 const handleFinancedName =() =>{
    if(router.asPath === '/machinery-loans-for-exporters-india'){
        return 'Apply Now for Machinery Loans'
    } else if(router.asPath === '/freight-invoice-discounting-india'){
        return 'Get Freight Invoice Discounting Now'
    } else if (router.asPath === '/import-factoring'){
        return 'Apply Now for Import Factoring'
    }
     else{
        return 'Get Financed'
    }
 }
 const handleFormTitle = () => {
    if (router.asPath === '/dealer-distributor-financing') {
      return (
        <h3 className='text-base2 text-secondary mb-3 font-medium'>
          Build a High-Performance Distributor Financing Engine
        </h3>
      );
    } else if (router.asPath === '/corporate-loan-against-property') {
      return (
        <h3 className='text-base2 text-secondary mb-3 font-medium'>
          Your Property Can Fund Growth — Today
        </h3>
      );
    } else if (router.asPath === '/machinery-capex-financing') {
      return (
        <h3 className='text-lg text-brand mb-3'>
          Get<span className='font-medium'> Machinery Loan</span>
        </h3>
      );
    } else {
      return (
        <h3 className='text-base text-secondary mb-3'>
          Get Up to <span className='font-bold'>90% Working Capital</span>{' '}
          <span>Of Your Invoice Value</span>{' '}
          <span className='font-bold'>Within 24 Hours</span>
        </h3>
      );
    }
  };
  const formTitle = handleFormTitle();

    return (

        <div className={`${router.asPath.includes(pageTitle) ? 'bg-none sm:px-0 sm:w-[375px]' : 'bg-white sm:px-2'} rounded-[15px] py-4 pb-6 px-5  lg:w-full lg:max-w-[450px] md:max-w-[400px] mx-auto md:relative md:m-auto md:mb-[20px]`}>
           
            <div className={`${router.asPath.includes(pageTitle) ? 'bg-[#FFFFFF] border border-[#D9D9D9]' : ''} border border-bordercolor rounded-md p-2 sm:p-1`}>
                 {formTitle}            
                    <div className="flex items-center mt-[5px]">
                        {/* Option 1 */}
                        {checkArray.map((item,i)=>(
                            <div key={i} className="flex items-center mr-3 sm:mr-1">
                            <input
                            type="checkbox"
                            id={item.id}
                            name={exportValue}
                            value={item.value}
                            checked={exportValue === item.value}
                            onChange={handleRadioButtonChange}
                            className="cursor-pointer h-3 w-3"
                            />
                            <label
                            htmlFor={item.id}
                            className={`cursor-pointer relative pl-1 text-base sm:text-sm text-[#022B5C]${
                                exportValue === item.value ? '' : ''
                            }`}
                            >
                            {item.name}
                           
                            </label>
                        </div>
                        ))}
                        </div>
                  
                {showUSDInput ? (
                    <>
                        <div className='mt-3'>
                                <label htmlFor="financeAmt" className="text-sm font-medium text-secondary">
                                    Finance Required*
                                </label>

                            <div className="mt-1 flex rounded-md">
                                <input value="USD" name='currency' aria-label="Currency" readOnly className="inline-flex w-[70px] justify-center text-base md:text-sm items-center h-6 rounded-l-md border border-bordercolor border-r-0 px-2 text-gray-500 sm:text-sm" />
                                <input
                                    name="financeAmt"
                                    value={financeAmt}
                                    onChange={financeAmount}
                                    id="financeAmt"
                                    placeholder="Enter Amount"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    aria-required="true"
                                    className="block w-full min-w-0 text-base md:text-sm flex-1 pl-1 rounded-none h-6 rounded-r-md border-0 py-1.5 ring-1 ring-inset ring-bordercolor focus:border-[#555] focus:ring-[#555] focus:outline-none"
                                />
                            </div>
                        </div>
                        {financeAmtError &&
                            <p className="text-progressColor4 text-xs mt-[3px]">This field is required with valid amount</p>}
                    </>
                ) : (
                    <div className='mt-3'>
                            <label htmlFor="financeAmtInr" className="text-sm font-medium text-secondary">
                                Finance Required*
                            </label>
                          

                        <div className="mt-1 flex rounded-md">
                            <input value="INR" name='currency' aria-label="Currency" readOnly className="inline-flex w-[70px] justify-center text-base md:text-sm items-center h-6 rounded-l-md border border-bordercolor border-r-0 px-2 text-gray-500 sm:text-sm" />
                            <input
                                value={financeAmt}
                                name="financeAmt"
                                onChange={financeAmount}
                                id="financeAmt"
                                placeholder="Enter Amount"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                aria-required="true"
                                className="block w-full min-w-0 text-base md:text-sm flex-1 pl-1 rounded-none h-6 rounded-r-md border-0 py-1.5  ring-1 ring-inset ring-bordercolor  focus:border-[#555] focus:ring-[#555] focus:outline-none"
                            />
                        </div>
                    </div>
                )}
                <div className='mt-3'>
                    <label htmlFor="phoneNumberCfForm" className="text-sm font-medium text-secondary">
                        Phone Number*
                    </label>
                    <div className='mt-1 flex relative'>
                        <input
                            value={phoneNumberCfForm}
                            name="phoneNumberCfForm"
                            onChange={checkPhoneCfForm}

                            id="phoneNumberCfForm"
                            type="tel"
                            inputMode="tel"
                            autoComplete="tel"
                            aria-required="true"
                            maxLength={10}
                            className="block w-full min-w-0 text-base md:text-sm flex-1 pl-1 h-6 rounded-md border-0 py-1.5  ring-1 ring-inset ring-bordercolor  focus:border-[#555] focus:ring-[#555] focus:outline-none"
                            placeholder="Phone Number"
                        />

                        {phVerifiedCfForm &&
                            <div className="absolute flex items-center top-[5px] right-[90px] sm:right-[85px] z-10 bg-[#E0FDDF] px-2 sm:px-1 text-xs text-[#299E22] h-[30px] rounded-md">
                                <span className='items-center flex'>
                                    <svg className='mr-[5px] ' xmlns="https://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24" width="13" height="13">
                                        <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z" fill="rgba(41,158,34,1)">
                                        </path>
                                    </svg>
                                    Verified
                                    
                                </span>

                            </div>
                        }
                        <button type='button' disabled={otpBtnDisabled} onClick={sendOTPCfForm} className={`top-0 bottom-0 absolute right-0 rounded-r-md text-xs text-center px-1 w-[81px] disabled:bg-[#ddd] disabled:text-[#888] disabled:cursor-not-allowed bg-yellowcolor text-black`}>
                            {loader ?
                                (<ColorRing
                                    visible={true}
                                    height="30"
                                    width="30"
                                    ariaLabel="blocks-loading"
                                    wrapperClass="ringForOtp"
                                    colors={['#000']}
                                />
                                ) :
                                'Send OTP'
                            }
                        </button>

                    </div>
                    {networkErrorCfForm &&
                        <div className='text-progressColor4 text-xs mt-[3px]'>Invalid captcha</div>
                    }
                    {phoneErrorMsg &&
                        <div className='text-progressColor4 text-xs mt-[3px]'>Please fill this with valid phone number.</div>
                    }
                    <div className='flex justify-end'>
                        {getOtp && (
                            <div className='flex justify-end text-sm mt-1'>
                                <span className='text-sm text-brand mr-[5px]'>Didn't get OTP? </span>Resend in {countdown}s</div>
                        )}
                    </div>
                </div>

                {showOtpField &&
                    <>
                        <label className='text-sm font-medium text-secondary mb-0 mt-2 block' htmlFor="digit1">Enter OTP</label>
                        <div className='flex flex-wrap justify-between mt-[5px]'>
                            <input className='h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[45px] sm:w-[40px]' type="text" id="digit1" aria-label="OTP Digit 1" inputMode="numeric" onChange={(e) => { verifyPhoneNumberCfForm, moveToNextInputCfForm(e.target, 'digit2') }} maxLength="1" pattern="[0-9]" required />
                            <input className='h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[45px] sm:w-[40px]' type="text" id="digit2" aria-label="OTP Digit 2" inputMode="numeric" onChange={(e) => { verifyPhoneNumberCfForm, moveToNextInputCfForm(e.target, 'digit3') }} maxLength="1" pattern="[0-9]" required />
                            <input className='h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[45px] sm:w-[40px]' type="text" id="digit3" aria-label="OTP Digit 3" inputMode="numeric" onChange={(e) => { verifyPhoneNumberCfForm, moveToNextInputCfForm(e.target, 'digit4') }} maxLength="1" pattern="[0-9]" required />
                            <input className='h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[45px] sm:w-[40px]' type="text" id="digit4" aria-label="OTP Digit 4" inputMode="numeric" onChange={(e) => { verifyPhoneNumberCfForm, moveToNextInputCfForm(e.target, 'digit5') }} maxLength="1" pattern="[0-9]" required />
                            <input className='h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[45px] sm:w-[40px]' type="text" id="digit5" aria-label="OTP Digit 5" inputMode="numeric" onChange={(e) => { verifyPhoneNumberCfForm, moveToNextInputCfForm(e.target, 'digit6') }} maxLength="1" pattern="[0-9]" required />
                            <input className='h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[45px] sm:w-[40px]' type="text" id="digit6" aria-label="OTP Digit 6" inputMode="numeric" onChange={verifyPhoneNumberCfForm} maxLength="1" pattern="[0-9]" required />
                        </div>
                        {otpNumericIncorrect && <div className='text-progressColor4 text-xs mt-[3px]'>Incorrect OTP</div>}
                        {otpIncorrect && <div className='text-progressColor4 text-xs mt-[3px]'>Please enter correct OTP</div>}
                    </>
                }
                <div className='mt-3'>
                    <label htmlFor="website" className="block text-sm font-medium leading-6 text-gray-900">
                    Company Website (Optional)
                    </label>
                    <div className="mt-1">
                        <input
                            type="website"
                            name="website"
                            value={website}
                            onChange={websiteUrl}
                            id="website"
                            autoComplete="url"
                            className="block w-full rounded-md border border-bordercolor h-6 py-1.5 px-2 text-base md:text-sm text-secondary focus:border-[#555] focus:ring-[#555] focus:outline-none"
                            placeholder="Enter your website"
                        />
                    </div>
                </div>
                <div className='mt-4'>
                    <button onClick={handleNext} className='disabled:bg-[#999] py-1 px-3 rounded-md text-white text-sm w-full bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]'>{handleFinancedName()}</button>
                </div>
                {allFieldsError &&
                    <p className='text-progressColor4 text-xs mt-[3px]'>Please fill in all required fields and verify your phone number via OTP.</p>
                }

            </div>
        </div>

    )
}

export default ContactFormStep1;